import React, { memo, useMemo } from "react";

import { useUsers } from "../providers/users-provider";
import { useAuth } from "../providers/auth-provider";
import MeUserProfile from "./me-user-profile";
import UserProfile from "./user-profile";

interface IProps {
  userId: string;
}

const UserProfileDrawer = ({ userId }: IProps) => {
  const { me } = useAuth();
  const { usersById } = useUsers();
  const user = useMemo(() => usersById[userId], [userId, usersById]);

  if (!user || !me) {
    return null;
  }

  if (userId === me.id) {
    return <MeUserProfile />;
  }

  return <UserProfile user={user} />;
};

export default memo(UserProfileDrawer);
